import React from "react";
import { Callout, Marker } from 'react-native-maps';
import { StyleSheet, Text, View } from "react-native";
import Icon from "react-native-vector-icons/Ionicons";
import logoMarker025x from '../../assets/marker/0.25x/viamais_pin.png';
import * as Colors from "../styles/colors";
import * as Fonts from "../styles/typography";
import { IS_WEB } from "@services/Config";

export default function UnityMarker({ mapRegion, idUnity, nameUnity, address, onPress, hasCallout = true, bigIcon = false, onPressCallout }) {
    // Don't render map components on web
    if (IS_WEB) {
        return null;
    }
    
    return <>
        <Marker
            key={idUnity}
            coordinate={mapRegion}
            image={logoMarker025x }
            onPress={onPress}>
            {hasCallout ? <Callout onPress={onPressCallout}>
                <View style={styles.viewPrincipal}>
                    <Text style={styles.name}>{nameUnity}</Text>
                    <Text style={styles.item}>{address}</Text>
                    <View style={styles.viewIcons}>
                        {/* <View style={styles.viewIcon}>
                                <Icon name={"navigate-circle"}
                                    size={30}
                                    style={styles.icon} 
                                    onPress={setStatePopUp(true)}/>
                                <Text style={styles.textIcon}>{"Navegar"}</Text>
                            </View> */}
                        <View style={styles.viewIcon}>
                            <Icon name={"ios-information-circle-sharp"}
                                size={35}
                                style={styles.icon} />
                            <Text style={styles.textIcon}>{"Informações"}</Text>
                        </View>
                    </View>
                </View>
            </Callout> : null}
        </Marker>
    </>
}

const styles = StyleSheet.create({
    viewPrincipal: {
        padding: 4,
        flex: 1,
        alignItems: 'center'
    },
    viewIcons: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 8
    },
    viewIcon: {
        alignItems: 'center',
        marginHorizontal: 8
    },
    icon: {
        color: Colors.PRIMARY
    },
    textIcon: {
        fontSize: Fonts.FONT_SIZE_12,
        color: Colors.TEXT,
        marginTop: 4
    },
    name: {
        fontSize: Fonts.FONT_SIZE_14,
        fontWeight: 'bold',
        color: Colors.TEXT,
        textAlign: 'center'
    },
    item: {
        fontSize: Fonts.FONT_SIZE_12,
        color: Colors.TEXT,
        textAlign: 'center',
        marginTop: 4
    }
});
